// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"MobileReviewAbsenceModal_modal_body__1IBV-","footer":"MobileReviewAbsenceModal_footer__3p0jx"};